import Image from "next/image";
import Link from "next/link";

export type BlogCardProps = {
  category: string;
  title: string;
  description: string;
  href: string;
  image?: string;
  imageAlt?: string;
  showCategory?: boolean;
};

export default function BlogCard({ category, title, description, href, image, imageAlt, showCategory = true }: BlogCardProps) {
  const cover = image ?? "/images/blog-boi.svg";
  return (
    <article className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white transition-[border-color,box-shadow] duration-500 ease-out hover:border-[#dbc14b] hover:shadow-[0_24px_50px_-32px_rgba(86,68,0,0.3)] focus-within:border-[#dbc14b] focus-within:ring-2 focus-within:ring-gray-950 focus-within:ring-offset-4">
        <div className="relative flex aspect-[128/67] items-center justify-center overflow-hidden bg-[#f6df69] p-2">
          <Image
            src={cover}
            alt={imageAlt ?? title}
            width={640}
            height={420}
            className="h-full w-full rounded-xl object-cover transition-[transform,filter] duration-[350ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[0.985] group-hover:brightness-[1.03] group-focus-within:scale-[0.985] group-focus-within:brightness-[1.03]"
            sizes="(min-width: 1280px) 400px, (min-width: 768px) 50vw, 100vw"
          />
        </div>
      <div className="flex flex-1 flex-col gap-3 p-6">
        {showCategory ? (
          <span className="w-fit border-b border-[#c8a900] pb-1 text-xs font-semibold text-[#806500]">
            {category}
          </span>
        ) : null}
        <div className="space-y-2">
          <h3 className="line-clamp-2 text-xl font-semibold leading-snug text-gray-950 transition-colors duration-300 group-hover:text-[#806500] group-focus-within:text-[#806500] md:min-h-[3.875rem]">
            <Link href={href} className="rounded-sm after:absolute after:inset-0 focus-visible:outline-none">
              {title}
            </Link>
          </h3>
          <p className="line-clamp-3 text-sm leading-7 text-slate-600 md:min-h-[5.25rem]">{description}</p>
        </div>
        <span className="mt-auto inline-flex w-fit items-center gap-2 pt-2 text-sm font-semibold text-gray-950 transition-[gap,color] duration-300 group-hover:gap-3 group-hover:text-[#806500]" aria-hidden="true">
          อ่านบทความ →
        </span>
      </div>
    </article>
  );
}
